type ConfettiOptions = {
  ticks?: number;
  particleCount?: number;
  spread?: number;
  angle?: number;
  startVelocity?: number;
  gravity?: number;
  decay?: number;
  origin?: { x?: number; y?: number };
  colors?: string[];
  zIndex?: number;
  disableForReducedMotion?: boolean;
};

declare global {
  interface Window {
    Meticulous?: {
      isRunningAsTest?: boolean;
    };
    confetti?: (options: ConfettiOptions) => void;
  }
}

export function launchConfetti(): void {
  launchConfettiBursts([
    {
      ticks: 100,
      particleCount: 100,
      spread: 70,
      origin: { y: 0.8 },
    },
  ]);
}

export function launchConfettiBursts(bursts: ConfettiOptions[]): void {
  if (window.Meticulous?.isRunningAsTest) return;

  setTimeout(() => {
    // we include a script in _document.tsx to load the js for this. Guard
    // against it being unavailable (e.g. CDN/SRI failure) so a missing confetti
    // animation never throws a ReferenceError that crashes the page.
    if (typeof window.confetti !== "function") return;
    for (const burst of bursts) {
      window.confetti({ zIndex: 10000, ...burst });
    }
  }, 0);
}

// The confetti script loads asynchronously from a CDN (see _document.tsx), so
// on a fresh page load it may not be ready yet. Resolves true once it is, or
// false if it never arrives within `timeoutMs`.
export function waitForConfetti(timeoutMs = 4000): Promise<boolean> {
  return new Promise((resolve) => {
    const startedAt = Date.now();
    const check = () => {
      if (typeof window.confetti === "function") return resolve(true);
      if (Date.now() - startedAt >= timeoutMs) return resolve(false);
      setTimeout(check, 100);
    };
    check();
  });
}
